<template>
  <div style="background: #fff;">
    <div style="font-size:30px;color:#000;font-weight:bold;margin: 34px 0 35px 120px;">Account Profile</div>
    <div style="font-size:24px;color:#000;font-weight:bold;margin:0 0 12px 120px;">Update Your Account Details</div>
    <div style="font-size:18px;color:#000;margin: 0 0 20px 120px;">Required Fields</div>
    <el-form autoComplete="on"
               :model="accountForm"
               :rules="accountRules"
               label-position="right" label-width="200px"
               ref="accountForm"
               class="box-content">
        <el-form-item prop="title" label="Title">
          <el-input name="title" class="ipt"
                    type="text"
                    v-model="accountForm.title"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="firstName" label="User ID">
          <el-input name="firstName" class="ipt"
                    type="text"
                    v-model="accountForm.firstName"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="lastName" label="Name">
          <el-input name="lastName" class="ipt"
                    type="text"
                    v-model="accountForm.lastName"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="emailAddress" label="Email Address">
          <el-input name="emailAddress" class="ipt"
                    type="text"
                    v-model="accountForm.emailAddress"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="industry" label="what industry are you in?">
          <el-checkbox-group v-model="accountForm.industry">
            <el-row>
              <el-col :span="12">
                <el-checkbox label="defense">Defense, Security, or Aerospace</el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="research">Research or University</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-checkbox label="semiconductor">Semiconductor Equipment</el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="manufacturing">Manufacturing</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-checkbox label="life">Life Sciences or Medical Technology</el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="measurement">Measurement or Automation Systems</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-checkbox label="raw">Raw Materials and Processing</el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox label="other">Other</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <a class="loginBtn a1" :loading="loading" @click="handleAccount">
            SAVE YOUR ACCOUNT DETAILS
          </a>
        </el-form-item>
      </el-form>
      <div style="font-size:24px;color:#000;font-weight:bold;margin:72px 0 55px 120px;">change Your Password</div>
      <el-form autoComplete="on"
               :model="passwordForm"
               :rules="passwordRules"
               label-position="right" label-width="200px"
               ref="passwordForm"
               class="box-content">
        <el-form-item label="Password Requirements">
          <p>x Password should be at least 6 characters in length.</p>
          <p>x Passwords must have at least one digit (0 - 9).</p>
          <p>x Passwords must have at least one lowercase ('a'-'z').</p>
          <p>x Passwords must have at least one uppercase ('A-Z)</p>
          <p>x Passwords must match.</p>
        </el-form-item>
        <el-form-item prop="oldPassword" label="Old Password">
          <el-input name="oldPassword" class="ipt"
                   :type="pwdType"
                    v-model="passwordForm.oldPassword"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="newPassWord" label="New Password">
          <el-input name="newPassWord" class="ipt"
                    :type="pwdType"
                    v-model="passwordForm.newPassWord"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="verifypassword" label="Verify Password">
          <el-input name="verifypassword" class="ipt"
                    :type="pwdType"
                    v-model="passwordForm.verifypassword"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item>
          <a class="loginBtn a1" style="margin-bottom:78px;" :loading="loading2" @click.native.prevent="handlePassword">
            RESET YOUR PASSWORD
          </a>
        </el-form-item>
      </el-form>
  </div>
</template>
<script>
    import { updatePass, updateAccountDetail, updateUserInfo } from '@/api/Persona/index' ;
    const defaultAccount = {
      title: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      industry: [],
    };
    const defaultPassword = {
      oldPassword: '',
      newPassWord: '',
      verifypassword: '',
    };
    export default {
        name: 'Accountprofile',
        components: {},
        data () {
          const emailAddress = (rule, value, callback) => {
            let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            if (!reg.test(value)) {
              callback(new Error('Please enter the correct email address'))
            } else {
              callback()
            }
          };
          const validatePass = (rule, value, callback) => {
            let reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,}$/;
            if (value.length < 6 && !reg.test(value)) {
              callback(new Error('The password shall be at least 6 digits and contain numbers, Letter case'))
            } else {
              callback()
            }
          };
            return {
              accountForm: Object.assign({}, defaultAccount),
              accountRules: {
                // title: [{required: true, message: 'Enter', trigger: 'blur'}],
                firstName: [{required: true, message: 'Enter',trigger: 'blur'}],
                lastName: [{required: true,message: 'Enter', trigger: 'blur'}],
                emailAddress: [{required: true, trigger: 'blur', validator: emailAddress}],
                // industry: [{type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}],
              },
              loading: false,
              loading2: false,
              passwordForm: Object.assign({}, defaultPassword),
              passwordRules: {
                oldPassword: [{required: true, message: 'Enter', trigger: 'blur'}],
                newPassWord: [{required: true, trigger: 'blur', validator: validatePass}],
                verifypassword: [{required: true,message: 'Enter', trigger: 'blur'}],
              },
              pwdType: 'passWord',
            }
        },
        methods: {
          showPwd() {
            if (this.pwdType === 'passWord') {
              this.pwdType = ''
            } else {
              this.pwdType = 'passWord'
            }
          },
          getUserInfo() {
              const params = {};
              updateUserInfo(params).then((res) => {
                console.log(res, 'updateUserInfo');
                this.accountForm = {...res};
                console.log(this.accountForm, 'this.accountForm');
                if (this.accountForm.industry != '') {
                  this.accountForm.industry = this.accountForm.industry.split(',')
                } else {
                  this.accountForm.industry = []
                }
              });
          },
          handleAccount() {
            console.log(this.accountForm.industry, 'this.accountForm.industry')
            const arr1 = this.accountForm.industry + '';
            this.$refs.accountForm.validate(valid => {
              if (valid) {
                this.loading = true;
                this.accountForm.industry = arr1;
                updateAccountDetail(this.accountForm).then((res) => {
                    this.getUserInfo();
                    console.log(res, 'accountForm');
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                });
              } else {
                return false
              }
            })
          },
          handlePassword() {
            this.$refs.passwordForm.validate(valid => {
              if (valid) {
                if (this.passwordForm.verifypassword != this.passwordForm.newPassWord) {
                    this.$message.error("Passwords must be entered consistently");
                } else {
                  this.loading = true;
                  updatePass(this.passwordForm).then((res) => {
                    console.log(res, 'passwordForm');
                    this.loading2 = false
                  }).catch(() => {
                    this.loading2 = false
                  });
                }
              } else {
                return false
              }
            })
          },
        },
        mounted() {
          this.getUserInfo();
        },
    }
</script>

<style scoped>
.box-content {
    width:1000px;
    margin: auto;
  }
  .login-title {
    font-size:30px;
    font-weight:bold;
    font-family:Arial;
    color:#000;
  }
  .ipt{
    width:572px;
    height:36px;
    border: 0 !important;
    outline: none;
  }
  ::v-deep .el-input__inner {
    border-radius: 0 !important;
    border: 1px solid #e1e1e1 !important;
    background-color: #fff !important;
  }
  ::v-deep input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  .loginBtn {
    background:#00718c;
    color: #fff;
    border-radius: 6px;
    font-size:20px;
    font-weight:bold;
    padding: 16px 12px;
  }
</style>